import { Button } from "@/components/ui/button";

const LABEL_CLASS_NAME =
  "bg-black-russian/95 rounded-[1px] shadow-0-0-10 shadow-black text-white text-13/[1.31em] font-medium py-[3px] px-2.5 block text-center";

interface ObscuredContentProps {
  onClick(): void;
}

export default function ObscuredContent({ onClick }: ObscuredContentProps) {
  return (
    <div className="relative">
      <p className="line-clamp-3 text-14/[1.5em] text-white md:text-pale-lavender">
        𓆜𓋘𓄁 𓊛𓇙𓋸𓌤𓌥 𓌦 𓅐𓆢 𓆣 𓀉𓆤 𓆥 𓅑𓆘 𓆙 𓅒𓄙 𓄚 𓄛 𓅓𓃺 𓃻 𓅔 𓅕 𓃕 𓃖 𓃗 𓎷 𓄁𓎸𓅖 𓅽 𓅾 𓅿𓅗 𓅘 𓇆 𓇇𓅙 𓅚 𓁵
        𓁶𓂵 𓂶𓃝𓋲 𓋳𓀬 𓅛𓁃 𓂺𓅜 �𓅝𓃄 �𓄁𓅞𓂙 𓅟𓂿 𓆜𓋘𓄁 𓊛𓇙𓋸𓌤𓌥 𓌦 𓅐𓆢 𓆣 𓀉𓆤 𓆥 𓅑𓆘 𓆙 𓅒𓄙 𓄚 𓄛 𓅓𓃺 𓃻 𓅔 𓅕 𓃕
        𓃖 𓃗 𓎷 𓄁𓎸𓅖 𓅽 𓅾 𓅿𓅗 𓅘 𓇆 𓇇𓅙 𓅚 𓁵 𓁶𓂵 𓂶𓃝𓋲 𓋳𓀬 𓅛𓁃 𓂺𓅜 𓂨𓅝𓃄 𓄁𓅞𓂙 𓅟𓂿
      </p>
      <Button
        className="group absolute inset-0 flex flex-col items-center justify-center gap-[3px]"
        onClick={onClick}
      >
        <span className={LABEL_CLASS_NAME}>This review contains spoilers.</span>
        <span className={LABEL_CLASS_NAME}>
          <span className="font-medium text-13 underline group-hover:no-underline">
            Unscramble
          </span>
          <span className="ml-1 text-14">𓀗</span>
        </span>
      </Button>
    </div>
  );
}
